<template>
  <section v-if="hasMedia" id="gallery" class="gallery-section">
    <v-container>
      <div v-if="imageMedia.length" class="gallery-group">
        <p>Captured Along the Way</p>
        <h2>{{ title }}</h2>
        <ResponsiveMediaGallery
          :items="imageMedia"
          :aria-label="title"
        />
      </div>
      <div v-if="videoMedia.length" class="gallery-group video-gallery">
        <p>Recorded Along the Way</p>
        <h2>Video Gallery</h2>
        <ResponsiveMediaGallery
          :items="videoMedia"
          aria-label="Video Gallery"
        />
      </div>
    </v-container>
  </section>
</template>

<script>
import ResponsiveMediaGallery from './ResponsiveMediaGallery.vue';
import { resolveMediaAssets } from '../../../services/mediaAssets';

export default {
  name: 'EventGallery',
  components: { ResponsiveMediaGallery },
  props: { media: { type: Array, default: () => [] }, title: { type: String, default: 'Event Gallery' } },
  data() {
    return {
      hydrationId: 0,
      resolvedMedia: [],
    };
  },
  computed: {
    imageMedia() { return this.resolvedMedia.filter((asset) => asset && asset.type !== 'video'); },
    videoMedia() { return this.resolvedMedia.filter((asset) => asset?.type === 'video' && asset.src); },
    hasMedia() { return this.imageMedia.length > 0 || this.videoMedia.length > 0; },
  },
  watch: {
    media: {
      immediate: true,
      handler(media) {
        this.hydrateMedia(media);
      },
    },
  },
  methods: {
    async hydrateMedia(media) {
      const hydrationId = this.hydrationId + 1;
      this.hydrationId = hydrationId;
      this.resolvedMedia = media.filter((asset) => asset && !asset.firebaseAssetId);

      const resolvedMedia = await resolveMediaAssets(media);
      if (this.hydrationId === hydrationId) this.resolvedMedia = resolvedMedia;
    },
  },
};
</script>

<style scoped>
.gallery-section { background: #050505; border-top: 1px solid #242424; padding: 72px 0; scroll-margin-top: 68px; }
.gallery-group > p { color: #e23232; font-family: "Oswald", sans-serif; font-weight: 800; text-transform: uppercase; }
.video-gallery { border-top: 1px solid #242424; margin-top: 64px; padding-top: 64px; }
h2 { color: #fff; font-family: "Oswald", sans-serif; font-size: 2.8rem; margin: 0 0 28px; }
</style>
